import { gql } from "@apollo/client";

export const DeleteInstalledBaseNodeAttributeOptionValue = gql`
    mutation DeleteInstalledBaseNodeAttributeOptionValue ($id: ID!){
        deleteInstalledBaseNodePropertyOptionValue (id: $id) {
            success
            message
        }
    }
`;
